import { v4 as uuid } from 'uuid';

export function createFieldKey(stepId: string, fieldId: string) {
  return `${stepId}.${fieldId}`;
}

export function createStepId(): string {
  return uuid();
}
